// http://doc.lgekr.lge.co.kr/docs/index.html#/pages/SWA/datadog-usage-guide/datadog_rum

(function (h, o, u, n, d, i) {
  // 이미 로딩된 경우 중복 로딩 방지 (예: 여러번 스크립트 로드된 경우)
  // SDK 중복 로딩 시 아래 콘솔 경고 로그 발생
  // "Datadog Browser SDK: SDK is loaded more than once. This is unsupported and might have unexpected behavior."
  if (h[i]) return;
  h[i] = true;

  h = h[d] = h[d] || {
    q: [],
    onReady: function (c) {
      h.q.push(c);
    },
  };

  d = o.createElement(u);
  d.async = 1;
  d.src = n;

  n = o.getElementsByTagName(u)[0];
  n.parentNode.insertBefore(d, n);
})(
  window,
  document,
  "script",
  "https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js",
  "DD_RUM",
  "DD_RUM_SDK_INSERTED"
);

window.DD_RUM &&
  window.DD_RUM.onReady &&
  window.DD_RUM.onReady(function () {
    // 이미 초기화된 경우 중복 초기화 방지
    // 중복 초기화 시 아래 콘솔 에러 로그 발생
    // "Datadog Browser SDK: DD_RUM is already initialized."
    if (window.DD_RUM_INITIALIZED) {
      return;
    }

    // 환경 값이 없으면 RUM 초기화하지 않음
    var envName = "prod";
    if (!envName) {
      return;
    }

    // 서비스 이름으로 현재 도메인명 사용
    var serviceName = window.location.hostname;

    // 테스트/로컬 도메인인 경우 RUM 초기화하지 않음
    if (serviceName.includes("local") || serviceName.includes("test")) {
      return;
    }

    // 기존에는 trackSessionAcrossSubdomains false 였기 때문에 _dd_s 쿠키가 전체 도메인에 생성됨.
    // 현재는 trackSessionAcrossSubdomains true 이기 때문에 서브 도메인(.lge.co.kr)에서만 쿠키가 생성됨.
    // 따라서 기존의 전체 도메인에 생성된 쿠키를 삭제함. (아래 코드로 서브 도메인 쿠키는 삭제되지 않음.)
    // 굳이 삭제하는 이유는, _dd_s 쿠키가 서로 다른 도메인(예: www.lge.co.kr, .lge.co.kr 모두)에 존재할 경우 RUM SDK가 올바른 쿠키를 읽지 못하는지 세션이 수집되지 않는 문제가 있음.
    // (_dd_s 쿠키는 1년 유효기간이므로 trackSessionAccrossSubdomains 설정 변경 후에도 남아있을 수 있음.)
    document.cookie = "_dd_s=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    window.DD_RUM.init({
      /* Authentication */
      applicationId: "1b333ea1-1ef5-4f0b-bb9b-a4c1c685730a",
      clientToken: "pub5e535baff3de5c456bc85aaa6853902a",

      /* Data Collection */
      env: envName,
      service: serviceName,
      sessionSampleRate: parseFloat("1"),
      sessionReplaySampleRate: 0,
      trackBfcacheViews: true,
      trackEarlyRequests: true,

      // major: 데이터독 RUM SDK 버전. RUM SDK Major 버전을 업그레이드하는 경우, 이 값을 함께 업그레이드 하고 별도 파일로 분리 (e.g., datadog-rum-v7.js)
      // minor: init 옵션을 추가 혹은 제거하거나, 동작 방식이 변경되는 중대한 설정 변화
      // patch: RUM sampling rate 변경과 같은 사소한 설정 변화
      version: "6.0.0",

      /* Tracing */
      // allowedTracingUrls: [/^https:\/\/[^\/]+\.lge\.co\.kr/],

      /* Session Persistence */
      sessionPersistence: "cookie",
      trackSessionAcrossSubdomains: true,
      useSecureSessionCookie: true,

      /* Transport */
      site: "datadoghq.com",
      // compressIntakeRequests: true,

      /* Other */
      storeContextsAcrossPages: true,
    });

    window.DD_RUM_INITIALIZED = true;
  });
